/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_Eb3_Point_2_TextInputs */

const en_visa_eb3_point_2_text = /** @type {(inputs: Visa_Eb3_Point_2_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rather than using broad assumptions about titles or industries, we review whether the facts support a viable employer-sponsored petition.`)
};

const pt_visa_eb3_point_2_text = /** @type {(inputs: Visa_Eb3_Point_2_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Em vez de usar suposições amplas sobre cargos ou setores, revisamos se os fatos apoiam uma petição viável patrocinada pelo empregador.`)
};

const es_visa_eb3_point_2_text = /** @type {(inputs: Visa_Eb3_Point_2_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En lugar de usar suposiciones amplias sobre cargos o industrias, revisamos si los hechos respaldan una petición viable patrocinada por el empleador.`)
};

/**
* | output |
* | --- |
* | "Rather than using broad assumptions about titles or industries, we review whether the facts support a viable employer-sponsored petition." |
*
* @param {Visa_Eb3_Point_2_TextInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_eb3_point_2_text = /** @type {((inputs?: Visa_Eb3_Point_2_TextInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_Eb3_Point_2_TextInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_eb3_point_2_text(inputs)
	if (locale === "es") return es_visa_eb3_point_2_text(inputs)
	return en_visa_eb3_point_2_text(inputs)
});